import api from './api';

const submissionService = {
  // Création d'une nouvelle soumission
  createSubmission: async (submissionData) => {
    return await api.post('/submissions', submissionData);
  },
  
  // Récupération de toutes les soumissions
  getSubmissions: async (params = {}) => {
    return await api.get('/submissions', { params });
  },
  
  // Récupération d'une soumission par ID
  getSubmissionById: async (submissionId) => {
    return await api.get(`/submissions/${submissionId}`);
  },
  
  // Mise à jour d'une soumission
  updateSubmission: async (submissionId, submissionData) => {
    return await api.put(`/submissions/${submissionId}`, submissionData);
  },
  
  // Suppression d'une soumission
  deleteSubmission: async (submissionId) => {
    return await api.delete(`/submissions/${submissionId}`);
  },

  // Ajoute un fichier à une soumission existante
  addFileToSubmission: async (submissionId, fileId) => {
    return await api.post(`/submissions/${submissionId}/files`, { fileId });
  },
  
  // Supprime un fichier d'une soumission
  removeFileFromSubmission: async (submissionId, fileId) => {
    return await api.delete(`/submissions/${submissionId}/files/${fileId}`);
  },
  
  // Met à jour l'ordre des fichiers d'une soumission
  updateFilesOrder: async (submissionId, fileOrders) => {
    return await api.put(`/submissions/${submissionId}/files/order`, { fileOrders });
  },
  
  // Récupère tous les fichiers d'une soumission
  getSubmissionFiles: async (submissionId) => {
    const response = await api.get(`/submissions/${submissionId}`);
    return response.data.submission.files || [];
  }
};

export default submissionService;